<template>
  <div v-if="loading" class="loading text-center">
    <idx-skeleton-chart type="map" />
  </div>
  <div v-else>
    <div>
      <div>
        <div class="row mt-4">
          <div class="col-12 text-center">
            <div class="align-map">
              <div
                style="
                  background: #f0f6fb;
                  padding-left: 20px;
                  padding-right: 20px;
                  border-radius: 20px;
                  font-size: 12px;
                "
              >
                <b-button-group>
                  <b-button
                    class="buttons-filters"
                    @click="changeMapType('brasil')"
                    v-bind:class="{
                      active: mapType === 'brasil',
                    }"
                    >{{ this.$t('reports.mapChart.brasil') }}</b-button
                  >
                  <b-button
                    class="buttons-filters"
                    @click="changeMapType('mundi')"
                    v-bind:class="{
                      active: mapType === 'mundi',
                    }"
                    >{{ this.$t('reports.mapChart.mapMundi') }}</b-button
                  >
                </b-button-group>
              </div>
            </div>

            <font-awesome-icon
              class="icon-filter"
              v-bind:class="{
                active: icon === 'map',
              }"
              @click="icon = 'map'"
              :icon="['fas', 'map-marker-alt']"
            />
            <font-awesome-icon
              class="icon-filter"
              v-bind:class="{
                active: icon === 'table',
              }"
              @click="icon = 'table'"
              :icon="['fas', 'table']"
            />

            <highcharts
              class="align-map"
              v-if="mapType === 'brasil' && icon === 'map'"
              :constructor-type="'mapChart'"
              :options="chartOptions"
            ></highcharts>

            <highcharts
              class="align-map"
              v-if="mapType === 'mundi' && icon === 'map'"
              :constructor-type="'mapChart'"
              :options="chartMundiOptions"
            ></highcharts>
          </div>
          <div
            v-if="icon === 'table'"
            style="
              align-items: center;
              justify-content: center;
              display: flex;
              margin-top: 5px;
            "
            class="col-12 text-center"
          >
            <b-table
              id="table-indicators"
              class="map-table"
              responsive
              striped
              :fields="fields"
              :items="(mapType === 'brasil' ? answersByUF : answersByLocale)"
              :style="`max-width: 500px; overflow-x: hidden; height: ${
                dataGraph.layout.h * 38
              }px;`"
            >
              <template v-slot:cell(nps)="row">
                <span
                  :style="`color: ${getNPSColor(
                    row.item.nps,
                  )}; font-weight: bold`"
                  >{{ row.item.nps }}</span
                >
              </template>
            </b-table>
          </div>
        </div>
        <div v-if="icon === 'map'" class="row">
          <div
            v-if="
              dataGraph.metric == 'nps-0-10' || dataGraph.metric == 'nps-1-5'
            "
            class="col-12 mt-5 subtitle-area"
          >
            <strong v-if="sizeLegend !== 12"
              >{{ this.$t('reports.mapChart.subtitleLabel') }}:
            </strong>
            <span class="nps-lt-0 legend-circle ml-2 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.npslt0')
            }}</span>
            <span class="nps-0-49 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.npslt50')
            }}</span>
            <span class="nps-50-69 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.npslt70')
            }}</span>
            <span class="nps-70-79 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.npslt80')
            }}</span>
            <span class="nps-80-100 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.npsge80')
            }}</span>
          </div>
          <div
            v-else-if="dataGraph.metric === 'ces-1-5'"
            class="col-12 mt-5 subtitle-area"
          >
            <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
            <span class="nps-lt-0 legend-circle ml-2 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.ceslt2')
            }}</span>
            <span class="nps-0-49 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.ceslt3')
            }}</span>
            <span class="nps-50-69 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">
              {{ this.$t('reports.mapChart.ceslt4') }}</span
            >
            <span class="nps-70-79 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.ceslt5')
            }}</span>
            <span class="nps-80-100 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.cesge5')
            }}</span>
          </div>
          <div
            v-else-if="dataGraph.metric === 'csat-0-10'"
            class="col-12 mt-5 subtitle-area"
          >
            <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
            <span class="nps-lt-0 legend-circle ml-2 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 0</span>
            <span class="nps-0-49 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 0 - 49</span>
            <span class="nps-50-69 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 50 - 69</span>
            <span class="nps-70-79 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 70 - 79</span>
            <span class="nps-80-100 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 80 - 100</span>
          </div>
          <div
            v-else-if="
              dataGraph.metric === 'csat-1-5' ||
              dataGraph.metric === 'csat-1-5(media)'
            "
            class="col-12 mt-5 subtitle-area"
          >
            <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
            <span class="nps-lt-0 legend-circle ml-2 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 1</span>
            <span class="nps-0-49 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 2</span>
            <span class="nps-50-69 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 3</span>
            <span class="nps-70-79 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 4</span>
            <span class="nps-80-100 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">CSAT 5</span>
          </div>
          <div
            v-else-if="dataGraph.metric === '5-stars'"
            class="col-12 mt-5 subtitle-area"
          >
            <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
            <span class="nps-lt-0 legend-circle ml-2 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.fiveStarslt2')
            }}</span>
            <span class="nps-0-49 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.fiveStarslt3')
            }}</span>
            <span class="nps-50-69 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.fiveStarslt4')
            }}</span>
            <span class="nps-70-79 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.fiveStarslt5')
            }}</span>
            <span class="nps-80-100 legend-circle ml-3 mr-2" />
            <span :style="`font-size: ${sizeLegend}px;`">{{
              this.$t('reports.mapChart.fiveStarsge5')
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Highcharts from 'highcharts';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import mapInit from 'highcharts/modules/map';
import mapData from '../brazil-data.json';
import mapDataMundi from '../world-data.json';
import EventBus from '../../../../../eventBus';
import api from '../../../../../services/api'

mapInit(Highcharts);

const BRstates = [
  'ac',
  'al',
  'ap',
  'am',
  'ba',
  'ce',
  'df',
  'es',
  'go',
  'ma',
  'mt',
  'ms',
  'mg',
  'pa',
  'pb',
  'pr',
  'pe',
  'pi',
  'rj',
  'rn',
  'rs',
  'ro',
  'rr',
  'sc',
  'sp',
  'se',
  'to',
];

const locales = [
  'AFG',
  'ZAF',
  'ALB',
  'DEU',
  'AND',
  'AGO',
  'AIA',
  'ATA',
  'ATG',
  'ANT',
  'SAU',
  'DZA',
  'ARG',
  'ARM',
  'ABW',
  'AUS',
  'AUT',
  'AZE',
  'BHS',
  'BHR',
  'BGD',
  'BRB',
  'BLR',
  'BEL',
  'BLZ',
  'BEN',
  'BMU',
  'BOL',
  'BIH',
  'BWA',
  'BRA',
  'BRN',
  'BGR',
  'BFA',
  'BDI',
  'BTN',
  'CPV',
  'CMR',
  'KHM',
  'CAN',
  'KAZ',
  'TCD',
  'CHL',
  'CHN',
  'CYP',
  'SGP',
  'COL',
  'COG',
  'PRK',
  'KOR',
  'CIV',
  'CRI',
  'HRV',
  'CUB',
  'DNK',
  'DJI',
  'DMA',
  'EGY',
  'SLV',
  'ARE',
  'ECU',
  'ERI',
  'SVK',
  'SVN',
  'ESP',
  'USA',
  'EST',
  'ETH',
  'FJI',
  'PHL',
  'FIN',
  'FRA',
  'GAB',
  'GMB',
  'GHA',
  'GEO',
  'GIB',
  'GBR',
  'GRD',
  'GRC',
  'GRL',
  'GLP',
  'GUM',
  'GTM',
  'GGY',
  'GUY',
  'GUF',
  'GIN',
  'GNQ',
  'GNB',
  'HTI',
  'NLD',
  'HND',
  'HKG',
  'HUN',
  'YEM',
  'BVT',
  'IMN',
  'CXR',
  'PCN',
  'REU',
  'ALA',
  'CYM',
  'CCK',
  'COM',
  'COK',
  'FRO',
  'FLK',
  'SGS',
  'HMD',
  'MNP',
  'MHL',
  'UMI',
  'NFK',
  'SYC',
  'SLB',
  'SJM',
  'TKL',
  'TCA',
  'VIR',
  'VGB',
  'WLF',
  'IND',
  'IDN',
  'IRN',
  'IRQ',
  'IRL',
  'ISL',
  'ISR',
  'ITA',
  'JAM',
  'JPN',
  'JEY',
  'JOR',
  'KEN',
  'KIR',
  'KWT',
  'LAO',
  'LVA',
  'LSO',
  'LBN',
  'LBR',
  'LBY',
  'LIE',
  'LTU',
  'LUX',
  'MAC',
  'MKD',
  'MDG',
  'MYS',
  'MWI',
  'MDV',
  'MLI',
  'MLT',
  'MAR',
  'MTQ',
  'MUS',
  'MRT',
  'MYT',
  'MEX',
  'FSM',
  'MOZ',
  'MDA',
  'MCO',
  'MNG',
  'MNE',
  'MSR',
  'MMR',
  'NAM',
  'NRU',
  'NPL',
  'NIC',
  'NER',
  'NGA',
  'NIU',
  'NOR',
  'NCL',
  'NZL',
  'OMN',
  'PLW',
  'PAN',
  'PNG',
  'PAK',
  'PRY',
  'PER',
  'PYF',
  'POL',
  'PRI',
  'PRT',
  'QAT',
  'KGZ',
  'CAF',
  'COD',
  'DOM',
  'CZE',
  'ROM',
  'RWA',
  'RUS',
  'ESH',
  'VCT',
  'ASM',
  'WSM',
  'SMR',
  'SHN',
  'LCA',
  'BLM',
  'KNA',
  'MAF',
  'STP',
  'SEN',
  'SLE',
  'SRB',
  'SYR',
  'SOM',
  'LKA',
  'SPM',
  'SWZ',
  'SDN',
  'SWE',
  'CHE',
  'SUR',
  'TJK',
  'THA',
  'TWN',
  'TZA',
  'IOT',
  'ATF',
  'PSE',
  'TMP',
  'TGO',
  'TON',
  'TTO',
  'TUN',
  'TKM',
  'TUR',
  'TUV',
  'UKR',
  'UGA',
  'URY',
  'UZB',
  'VUT',
  'VAT',
  'VEN',
  'VNM',
  'ZMB',
  'ZWE',
];

export default {
  components: {
    RadialProgressBar,
    animatedNumber,
    idxSkeletonChart,
  },

  props: ['dataGraph'],

  data: () => ({
    mapType: 'brasil',
    loading: true,
    userAuth: null,
    chartOptions: {
      title: {
        text: '',
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: 'bottom',
        },
      },
      legend: {
        enabled: false,
      },
      chart: {
        height: 450,
      },
      colorAxis: {
        min: 0,
      },
      path: {
        stroke: 'white',
      },
      series: [
        {
          data: [],
          mapData,
          joinBy: 'hc-key',
          name: 'NPS',
          nullColor: '#D8D8D8',
          borderColor: '#FFF',
          dataLabels: {
            enabled: true,
          },
        },
      ],
    },
    chartMundiOptions: {
      title: {
        text: '',
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: 'bottom',
        },
      },
      legend: {
        enabled: false,
      },
      chart: {
        height: 450,
      },
      colorAxis: {
        min: 0,
      },
      path: {
        stroke: 'white',
      },
      series: [
        {
          data: [],
          mapData: mapDataMundi,
          joinBy: ['iso-a3', 'code3'],
          name: 'NPS',
          nullColor: '#D8D8D8',
          borderColor: '#FFF',
          dataLabels: {
            enabled: true,
          },
        },
      ],
    },
    fields: [],
    answersByUF: [],
    answersByLocale: [],
    isPanel: false,
    icon: 'map',
    col: 'col-6',
    sizeLegend: 12,
  }),

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.isPanel = true;
    this.changeLabel();
    await this.getNPSByUFPanel(this.dataGraph);

    EventBus.$on('update-map', (items) => {
      this.getNPSByUFPanel(items);
    });
  },

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),

    answersByUFConverted() {
      const chartFormat = [];

      this.answersByUF.forEach((el) => {
        chartFormat.push({
          'hc-key': `br-${el.uf}`.toLowerCase(),
          value: el.nps,
          color: el.color,
        });
      });

      return chartFormat;
    },

    answersByLocaleConverted() {
      const chartFormat = [];

      this.answersByLocale.forEach((el) => {
        chartFormat.push({
          code3: `${el.locale}`.toUpperCase(),
          value: el.nps,
          color: el.color,
        });
      });
      return chartFormat;
    },
  },

  watch: {
    'dataGraph.layout.w': function watchLayoutWeight(weight) {
      if (weight <= 8) {
        this.sizeLegend = 12;
      } else {
        this.sizeLegend = 16;
      }
    },
  },

  methods: {
    ...mapActions('charts', ['setMapChart', 'setMapChartMundi']),

    returnLabel(){
       if (this.dataGraph.metric.indexOf('nps') !== -1) {
        return 'Nps';
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        return 'Ces';
      } else if (this.dataGraph.metric === 'csat-1-5') {
        return 'Csat';
      } else if (this.dataGraph.metric === 'csat-1-5(media)') {
        return 'Csat(media)';
      } else if (this.dataGraph.metric.indexOf('stars') !== -1) {
        return 'Stars';
      } else if (this.dataGraph.metric === 'like-dislike') {
        return 'Like-Dislike'
      }
      return '-';
    },

    async getNPSByUFPanel(data) {
      this.loading = true;

      const response = await api.get(`/reports/map-chart-panel/${this.userAuth.companyId}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId: data.actionId ? data.actionId._id : null,
            ih1:  data.ih1.length > 0 ? data.ih1.map((item) => item._id): null,
            startDate: null,
            endDate: null,
            period: data.period ? data.period : null,
            metric: data.metric ? data.metric : null,
            groupId: data.actionGroupId ? data.actionGroupId._id : null,
            indicator: data.indicator ? data.indicator : null,
            indicatorValue: data.valueIndicator ? data.valueIndicator : null,
            _id: this.dataGraph._id,
          },
      })

      this.answersByUF = response.data;

      this.chartOptions.series[0].data = [];
      this.chartOptions.series[0].name = this.returnLabel();

      const newAnswers = [];

      this.answersByUF.forEach((answer) => {
        if (answer.uf) {
          answer.uf = answer.uf.trim().toLowerCase();

          if (BRstates.includes(answer.uf)) {
            newAnswers.push(answer);
          }
        }
      });

      this.answersByUF = newAnswers;

      this.setNPSColorsToUF(this.answersByUF);

      this.chartOptions.series[0].data = this.answersByUFConverted;

      this.loading = false;
    },

    changeMapType(type) {
      this.mapType = type;
      if (type === 'brasil') {
        this.getNPSByUFPanel(this.dataGraph);
      } else {
        this.getNPSByLocalePanel();
      }
      this.changeLabel();
    },

    async getNPSByUF() {
      this.loading = true;

      this.chartOptions.series[0].data = [];

      const response = await api.get(`/reports/map-chart-panel/${this.userAuth.companyId}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId: this.dataGraph.actionId ? this.dataGraph.actionId._id : null,
            ih1:  this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
            startDate: null,
            endDate: null,
            period: this.dataGraph.period ? this.dataGraph.period : null,
            metric: this.dataGraph.metric ? this.dataGraph.metric : null,
            groupId: this.dataGraph.actionGroupId ? this.dataGraph.actionGroupId._id : null,
            indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
            indicatorValue: this.dataGraph.valueIndicator ? this.dataGraph.valueIndicator : null,
            _id: this.dataGraph._id,
          },
      })

      this.answersByUF = response.data;

      const newAnswers = [];

      this.answersByUF.forEach((answer) => {
        if (answer.uf) {
          answer.uf = answer.uf.trim().toLowerCase();

          if (BRstates.includes(answer.uf)) {
            newAnswers.push(answer);
          }
        }
      });

      this.answersByUF = newAnswers;

      this.setNPSColorsToUF(this.answersByUF);

      this.chartOptions.series[0].data = this.answersByUFConverted;

      this.loading = false;
    },

    async getNPSByLocalePanel() {
      this.loading = true;

      this.chartMundiOptions.series[0].data = [];

      const response = await api.get(`/reports/map-chart-mundi-panel/${this.userAuth.companyId}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId: this.dataGraph.actionId ? this.dataGraph.actionId._id : null,
            ih1:  this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
            startDate: null,
            endDate: null,
            period: this.dataGraph.period ? this.dataGraph.period : null,
            metric: this.dataGraph.metric ? this.dataGraph.metric : null,
            groupId: this.dataGraph.actionGroupId ? this.dataGraph.actionGroupId._id : null,
            indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
            indicatorValue: this.dataGraph.valueIndicator ? this.dataGraph.valueIndicator : null,
            _id: this.dataGraph._id,
          },
      })

      this.answersByLocale = response.data;

      const newAnswers = [];

      this.answersByLocale.forEach((answer) => {
        if (answer.locale) {
          answer.locale = answer.locale.trim().toUpperCase();

          if (locales.includes(answer.locale)) {
            newAnswers.push(answer);
          }
        }
      });

      this.answersByLocale = newAnswers;

      this.setNPSColorsToLocale(this.answersByLocale);

      this.chartMundiOptions.series[0].data = this.answersByLocaleConverted;

      this.loading = false;
    },
    getNPSColor(nps) {
      let color = '';
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        if (nps >= 80) {
          color = '#6bca6c';
        } else if (nps < 80 && nps >= 70) {
          color = '#9fd77a';
        } else if (nps < 70 && nps >= 50) {
          color = '#fbcf3f';
        } else if (nps < 50 && nps >= 0) {
          color = '#fa834f';
        } else if (nps < 0) {
          color = 'red';
        }
      } else if (
        this.dataGraph.metric.indexOf('ces') !== -1 ||
        this.dataGraph.metric.indexOf('stars') !== -1 ||
        this.dataGraph.metric.indexOf('csat-1-5') !== -1
      ) {
        if (nps >= 5) {
          color = '#6bca6c';
        } else if (nps < 5 && nps >= 4) {
          color = '#9fd77a';
        } else if (nps < 4 && nps >= 3) {
          color = '#fbcf3f';
        } else if (nps < 3 && nps >= 2) {
          color = '#fa834f';
        } else if (nps < 2) {
          color = 'red';
        }
      }
      if (this.dataGraph.metric.indexOf('like-dislike') !== -1) {
        if (nps >= 80) {
          color = '#6bca6c';
        } else if (nps < 79) {
          color = 'red';
        }
      }

      return color;
    },

    setNPSColorsToUF(answersByUF) {
      answersByUF.forEach((answers) => {
        answers.color = this.getNPSColor(answers.nps);
      });
    },

    setNPSColorsToLocale(answersByLocale) {
      answersByLocale.forEach((answers) => {
        answers.color = this.getNPSColor(answers.nps);
      });
    },

    formatToPrice(value) {
      if (
        this.dataGraph.metric.indexOf('nps') !== -1 ||
        this.dataGraph.metric.indexOf('csat') !== -1
      ) {
        return value.toFixed(0);
      }
      return value.toFixed(1);
    },

    changeLabel() {
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        this.fields = [
          {
            key: this.mapType === 'brasil' ? 'uf' : 'locale',
            label:
              this.mapType === 'brasil'
                ? this.$t('reports.mapChart.ufLabel')
                : this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: this.$t('reports.npsLabel'),
            sortable: true,
          },
        ];
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        this.fields = [
          {
            key: this.mapType === 'brasil' ? 'uf' : 'locale',
            label:
              this.mapType === 'brasil'
                ? this.$t('reports.mapChart.ufLabel')
                : this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: this.$t('reports.cesLabel'),
            sortable: true,
          },
        ];
      } else if (this.dataGraph.metric === 'csat-1-5') {
        this.fields = [
          {
            key: this.mapType === 'brasil' ? 'uf' : 'locale',
            label:
              this.mapType === 'brasil'
                ? this.$t('reports.mapChart.ufLabel')
                : this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: 'CSAT',
            sortable: true,
          },
        ];
      } else if (this.dataGraph.metric === 'csat-1-5(media)') {
        this.fields = [
          {
            key: this.mapType === 'brasil' ? 'uf' : 'locale',
            label:
              this.mapType === 'brasil'
                ? this.$t('reports.mapChart.ufLabel')
                : this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: 'CSAT (Média)',
            sortable: true,
          },
        ];
      } else if (this.dataGraph.metric.indexOf('stars') !== -1) {
        this.fields = [
          {
            key: this.mapType === 'brasil' ? 'uf' : 'locale',
            label:
              this.mapType === 'brasil'
                ? this.$t('reports.mapChart.ufLabel')
                : this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: '5Stars',
            sortable: true,
          },
        ];
      } else if (this.dataGraph.metric === 'like-dislike') {
        this.fields = [
          {
            key: this.mapType === 'brasil' ? 'uf' : 'locale',
            label:
              this.mapType === 'brasil'
                ? this.$t('reports.mapChart.ufLabel')
                : this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: 'Like/Dislike',
            sortable: true,
          },
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.align-map {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.icon-filter {
  color: #e8e8e8;
  cursor: pointer;
}

.icon-filter.active {
  color: #5e5e5e;
  cursor: pointer;
}

.buttons-filters {
  background: #f0f6fb;
  border-radius: 50rem;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  outline: none;
  font-size: 12px;
}

.buttons-filters.active {
  background: #fff !important;
  border-radius: 50rem !important;
  padding-left: 15px !important ;
  padding-right: 15px !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 50% !important;
}

.table-area {
  display: flex;
  justify-content: center;
  max-height: 600px;
  overflow-y: auto;
}

.subtitle-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.legend-circle {
  min-height: 15px;
  min-width: 15px;
}

.nps-lt-0 {
  border-radius: 50%;
  background-color: #ff0000;
}

.nps-0-49 {
  border-radius: 50%;
  background-color: #fa834f;
}

.nps-50-69 {
  border-radius: 50%;
  background-color: #fbcf3f;
}

.nps-70-79 {
  border-radius: 50%;
  background-color: #9fd77a;
}

.nps-80-100 {
  border-radius: 50%;
  background-color: #6bca6c;
}
// .radial-progress-inner {
//   span {
//     font-size: 16px !important;
//   }
// }
.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/map-chart/panels/map.vue